const getAdvertisementData = (advertisements, keyArray) => {
    const data = {}

    keyArray.map(key => data[key] = [])

    if(advertisements && advertisements.order) {
        advertisements.order.map(id => {
            const item = advertisements.items[id]

            if(data.hasOwnProperty(item.type))  {
                data[item.type].push(item)
            }
        })
    }

    return data
}

export default getAdvertisementData
